// Vendor
import { EventEmitter } from '@angular/core';
// Constants
import { RELATIVE_ATTRIBUTION_EXPANDABLE_CATEGORIZATIONS } from 'SecuritiesApp/ts/features/attribution-relative/constants';
// Interfaces
import { AttributionCategorization, PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i4 from "../../../module-upsell/module-upsell.component";
import * as i5 from "../attribution-relative-zoom-controls/attribution-relative-zoom-controls.component";
const _c0 = a0 => ({ "min-height-220": a0 });
const _c1 = a0 => ({ "pl-20": a0 });
const _c2 = a0 => ({ "collapsed": a0 });
function AttributionRelativeTableComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.errorMessage);
} }
function AttributionRelativeTableComponent_div_12_table_2_ng_container_43_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function AttributionRelativeTableComponent_div_12_table_2_ng_container_43_div_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const category_r5 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(category_r5.expanded = !category_r5.expanded); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, !category_r5.expanded));
} }
function AttributionRelativeTableComponent_div_12_table_2_ng_container_43_ng_container_24_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 20)(2, "div", 34)(3, "a", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "td", 30);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 30);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 30);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 30);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td", 30);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 30);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td", 30);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "td");
    i0.ɵɵelementStart(20, "td", 30)(21, "span", 26);
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const holding_r6 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("href", holding_r6.securityUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(holding_r6.securityId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.securityWeight);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.securityReturn);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.benchmarkWeight);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.benchmarkReturn);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.allocation);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.selection);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.interaction);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(holding_r6.total);
} }
function AttributionRelativeTableComponent_div_12_table_2_ng_container_43_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AttributionRelativeTableComponent_div_12_table_2_ng_container_43_ng_container_24_tr_1_Template, 23, 10, "tr", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const category_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r5.holdings);
} }
function AttributionRelativeTableComponent_div_12_table_2_ng_container_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr")(2, "td", 20)(3, "div", 28);
    i0.ɵɵtemplate(4, AttributionRelativeTableComponent_div_12_table_2_ng_container_43_div_4_Template, 1, 3, "div", 29);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "td", 30);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 30);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 30);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 30);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 30);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td", 30);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td", 30);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "td");
    i0.ɵɵelementStart(21, "td", 31)(22, "span", 26);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(24, AttributionRelativeTableComponent_div_12_table_2_ng_container_43_ng_container_24_Template, 2, 1, "ng-container", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const category_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1, ctx_r2.showExpandableCategories));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showExpandableCategories);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", category_r5.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.portfolioWeight);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.portfolioReturn);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.benchmarkWeight);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.benchmarkReturn);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.allocation);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.selection);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.interaction);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", category_r5.totalCellColorClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.total);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", category_r5.expanded);
} }
function AttributionRelativeTableComponent_div_12_table_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 19)(1, "thead")(2, "tr");
    i0.ɵɵelement(3, "td", 20);
    i0.ɵɵelementStart(4, "td", 21);
    i0.ɵɵtext(5, "Weight & Returns");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 22);
    i0.ɵɵtext(7, "Attribution Data");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "tr")(9, "td", 23);
    i0.ɵɵelement(10, "br");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 24);
    i0.ɵɵtext(13, " Portfolio ");
    i0.ɵɵelement(14, "br");
    i0.ɵɵtext(15, " Weight ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td", 24);
    i0.ɵɵtext(17, " Portfolio ");
    i0.ɵɵelement(18, "br");
    i0.ɵɵtext(19, " Return ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td", 24);
    i0.ɵɵtext(21, " Benchmark ");
    i0.ɵɵelement(22, "br");
    i0.ɵɵtext(23, " Weight ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "td", 24);
    i0.ɵɵtext(25, " Benchmark ");
    i0.ɵɵelement(26, "br");
    i0.ɵɵtext(27, " Return ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "td", 24);
    i0.ɵɵelement(29, "br");
    i0.ɵɵtext(30, "+/- Allocation ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "td", 24);
    i0.ɵɵelement(32, "br");
    i0.ɵɵtext(33, "+/- selection ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "td", 24);
    i0.ɵɵelement(35, "br");
    i0.ɵɵtext(36, "+/- interaction ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "td", 25);
    i0.ɵɵelementStart(38, "td", 24);
    i0.ɵɵelement(39, "br");
    i0.ɵɵelementStart(40, "div", 26);
    i0.ɵɵtext(41, "Total");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(42, "tbody");
    i0.ɵɵtemplate(43, AttributionRelativeTableComponent_div_12_table_2_ng_container_43_Template, 25, 15, "ng-container", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate1("", ctx_r2.categorizationLabels[ctx_r2.categorization], " ");
    i0.ɵɵadvance(32);
    i0.ɵɵproperty("ngForOf", ctx_r2.displayCategories);
} }
function AttributionRelativeTableComponent_div_12_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 36);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function AttributionRelativeTableComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, AttributionRelativeTableComponent_div_12_table_2_Template, 44, 2, "table", 16)(3, AttributionRelativeTableComponent_div_12_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵtext(5, "Expanded sections include top 10 holdings per category.");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
} }
export class AttributionRelativeTableComponent {
    constructor() {
        this.errorMessage = '';
        this.asOfDateOption = '';
        this.periodicityChangeHandler = new EventEmitter();
        this.showExpandableCategories = false;
        this.categorizationLabels = {
            [AttributionCategorization.SECTOR]: 'Sector',
            [AttributionCategorization.EQUITY_STYLE]: 'Equity Style',
            [AttributionCategorization.BOND_SECTOR]: 'Bond Sector',
            [AttributionCategorization.BOND_MATURITY]: 'Bond Maturity',
            [AttributionCategorization.BROAD_ASSET_CLASS]: 'Broad Asset Class',
        };
    }
    ngOnChanges() {
        this.showExpandableCategories = RELATIVE_ATTRIBUTION_EXPANDABLE_CATEGORIZATIONS.includes(this.categorization);
    }
    updatePeriodicity(periodicity) {
        this.periodicityChangeHandler.emit(periodicity);
    }
}
AttributionRelativeTableComponent.ɵfac = function AttributionRelativeTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionRelativeTableComponent)(); };
AttributionRelativeTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionRelativeTableComponent, selectors: [["ycn-attribution-relative-table"]], inputs: { categorization: "categorization", performancePeriodicity: "performancePeriodicity", displayCategories: "displayCategories", loading: "loading", errorMessage: "errorMessage", asOfDateOption: "asOfDateOption" }, outputs: { periodicityChangeHandler: "periodicityChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 15, vars: 8, consts: [["relativeAttributionTableHelpModal", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], [1, "panel-actions"], [1, "panel-action"], [3, "periodicityChangeHandler", "performancePeriodicity", "asOfDateOption"], [1, "panel-content", 3, "ngClass"], [3, "title"], ["class", "toast toast-error", 4, "ngIf"], ["class", "company-financials-table-wrap", "style", "margin-right: 0px;", 4, "ngIf"], [1, "toast", "toast-error"], [1, "toast-text"], [1, "company-financials-table-wrap", 2, "margin-right", "0px"], [1, "company-financials-table", 2, "margin-left", "190px"], ["class", "table border-0", 4, "ngIf"], [3, "loaderMessage", 4, "ngIf"], [1, "panel-date"], [1, "table", "border-0"], [1, "table-dynamic-name-middle"], ["colspan", "4", 1, "cell-group-header", "text-bold", "text-center"], ["colspan", "5", 1, "cell-group-header", "text-bold", "text-center"], [1, "border-0", "table-dynamic-name-middle", "text-thin"], [1, "border-0", "text-right", "text-thin"], [1, "border-0", "td-empty"], [1, "pr-1"], [4, "ngFor", "ngForOf"], [1, "relative", 3, "ngClass"], ["class", "collapse-mark", 3, "ngClass", "click", 4, "ngIf"], [1, "text-right"], [1, "text-right", 3, "ngClass"], [4, "ngIf"], [1, "collapse-mark", 3, "click", "ngClass"], [1, "relative", "pl-20"], [3, "href"], [3, "loaderMessage"]], template: function AttributionRelativeTableComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3", 3);
        i0.ɵɵtext(3, "Attribution Table\u00A0 ");
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function AttributionRelativeTableComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const relativeAttributionTableHelpModal_r2 = i0.ɵɵreference(14); return i0.ɵɵresetView(relativeAttributionTableHelpModal_r2.openModal("attribution_relative_table")); });
        i0.ɵɵtext(5, " (?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "ycn-attribution-relative-zoom-controls", 7);
        i0.ɵɵlistener("periodicityChangeHandler", function AttributionRelativeTableComponent_Template_ycn_attribution_relative_zoom_controls_periodicityChangeHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelement(10, "ycn-module-upsell", 9);
        i0.ɵɵtemplate(11, AttributionRelativeTableComponent_div_11_Template, 3, 1, "div", 10)(12, AttributionRelativeTableComponent_div_12_Template, 6, 2, "div", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(13, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("performancePeriodicity", ctx.performancePeriodicity)("asOfDateOption", ctx.asOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx.errorMessage));
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", "Attribution Table");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.errorMessage);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.HelpModalComponent, i3.LoadingSymbolComponent, i4.ModuleUpsellComponent, i5.AttributionRelativeZoomControlsComponent], encapsulation: 2 });
